import React from "react";

import ImpresszumModel from "../components/impresszum/Impresszum";

const Impresszum = () => {
  return <ImpresszumModel />;
};

export default Impresszum;
